import type { SVGProps } from 'react';
const SvgTextFileStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Text File Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M16.518 16.518a1.32 1.32 0 0 1-1.322 1.321H3.304a1.32 1.32 0 0 1-1.322-1.321V1.982A1.32 1.32 0 0 1 3.304.661h8.589l4.625 4.625zM5.946 5.946H8.59M5.946 9.91h6.608M5.946 13.875h6.608" />
    </g>
  </svg>
);
export default SvgTextFileStreamlineCore;
